export enum RoutePath {
    Create = 'create',
    Default = '',
    Redirect = '**',
    HealthCheck = 'health-check',
}
